// extracted by mini-css-extract-plugin
export var addToCartButton = "_tz-b";
export var arrowButtonContainer = "_tz-9";
export var arrowButtonIcon = "_tz-a";
export var carouselArrowButton = "_tz-6";
export var carouselElementContainer = "_tz-1";
export var left = "_tz-7";
export var productDisplayCarouselContainer = "_tz-0";
export var productTileContainer = "_tz-2";
export var productTileImage = "_tz-4";
export var productTileImageContainer = "_tz-3";
export var productTileTitle = "_tz-5";
export var right = "_tz-8";
export var sliderOverflow = "_tz-c";